export default () => {
  document.querySelectorAll(".js-article-metadata").forEach((parentEl) => {
    const initReadTime = () => {
      const readtimeEl = parentEl.querySelector(".js-am-read-time");

      if (!readtimeEl) {
        return false;
      }

      const wordsPerMinute = 225;
      let readTime = 0;

      document.querySelectorAll(".js-rich-text").forEach((el) => {
        const text = el.innerText;
        const wordCount = text.trim().split(/\s+/).length;
        readTime = readTime + Math.ceil(wordCount / wordsPerMinute);
      });

      if (readTime > 0) {
        readtimeEl.innerText = readTime;
      } else {
        readtimeEl.parentNode.remove();
      }
    };

    initReadTime();
  });
};
